export const authHeader = (headers: Headers) => {
    const token = localStorage.getItem('accessToken');
    headers.set('Authorization', `Bearer ${token}`);
    return headers;
};
